import React from 'react';
import { CreditCard } from 'lucide-react';
import { getIconProps, IconProps } from '../utils/props';

/** Billing & subscription card icon (sales domain, not freight invoice). */
export const BillingIcon: React.FC<IconProps> = props => {
  const iconProps = getIconProps(props);
  return <CreditCard {...iconProps} />;
};
